import { ba } from "api/endpoints";
import { importView } from "../utils/misc";

const AccountList = importView("Account/List");
const ProductList = importView("Product/List");
const ProductForm = importView("Product/Form");
const NostroList = importView("Nostro/List");
const BankAcnts = importView("BankAcnts/List");
const StatementList = importView("Statement");
const Config = importView("Config");
const TxnForm = importView("txn");
const TxnOut = importView("txn/fin/TxnOut");
const Transrqsts = importView("txn/fin/Transrqsts");
const BaTxnBa = importView("txn/fin/BaTxnBa");
const BaTxnDp = importView("txn/fin/BaTxnDp");
// const AcntC1 = importView("txn/fin/AcntC1");
// const Acnt2Acnt = importView("txn/fin/Acnt2Acnt");
// const AcntOpen = importView("txn/nonfin/AcntOpen");
// const AcntClose = importView("txn/nonfin/AcntClose");
// const ProdOpen = importView("txn/nonfin/ProdOpen");
// const ProdClose = importView("txn/nonfin/ProdClose");

const baRoutes = {
  path: "/",
  children: [
    {
      path: ba.products,
      element: <ProductList />,
    },
    {
      path: ba.product,
      element: <ProductForm />,
    },
    {
      path: ba.accounts,
      element: <AccountList />,
    },
    {
      path: ba.nostros,
      element: <NostroList />,
    },
    {
      path: ba.bankAccount,
      element: <BankAcnts />,
    },
    {
      path: ba.stmts,
      element: <StatementList />,
    },
    {
      path: ba.config,
      element: <Config />,
    },
    {
      path: ba.txn,
      element: <TxnForm />,
    },
    {
      path: ba.transrqsts,
      element: <Transrqsts />,
    },
    {
      path: ba.txnOut,
      element: <TxnOut />,
    },
    {
      path: ba.txnBa,
      element: <BaTxnBa />,
    },
    {
      path: ba.txnWithDp,
      element: <BaTxnDp />,
    },
  ],
};

export default baRoutes;
